import React, { useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Upload } from 'antd';
import { ApiUrl } from '../../project/Defines';
import ListView from '../../Shared/ListView';
import { COLUMN_TYPE } from '../../Shared/ListView/helper';
import { EVENT_NAME } from '../../project/utilities';
import { PopupClasses, PopupTypes } from '../../components/Popup';
import { openPopup } from '../../store/actions';
import { InformationImport, InformationExport } from './actions/informationAction';
import ImportInformation from './importDetail';

function Information(props) {
    const { network } = props;
    const dispatch = useDispatch();
    const [count, setCount] = useState(0);
    const listUpdateEvent = EVENT_NAME.INFORMATION_LIST_UPDATE;

    const importData = (file) => {
        const windowKey = 'importInformationWnd';
        InformationImport(file, listUpdateEvent, (response) => {
            if (response && response.Data) {
                dispatch(openPopup({
                    component: ImportInformation,
                    windowKey,
                    title: "Import",
                    type: PopupTypes.Popup,
                    fullScreen: false,
                    bodyProps: { windowKey, fileData: response.Data }
                }));
            }
        });
    };

    const columns = [
        {
            text: 'text.type',
            field: 'type',
            type: COLUMN_TYPE.TEXT
        },
        {
            text: 'text.title',
            field: 'title',
            type: COLUMN_TYPE.TEXT,
            render: (text, record) => (
                <wrap><text>{record.type === 'url' ? record.url : record.title}</text></wrap>
            )
        },
        {
            type: COLUMN_TYPE.ACTION
        }
    ];

    return (
        <div className="form_container">
            <ListView
                isSimple
                columnConfig={columns}
                apiUrl={ApiUrl.InformationList}
                deleteUrl={ApiUrl.InformationDelete}
                additionalData={{ salesNetworkId: +network }}
                detailProps={{
                    fullScreen: false,
                    popupType: PopupTypes.Information,
                    className: PopupClasses.Large,
                }}
                listUpdateEvent={listUpdateEvent}
                staticFilter={{ salesNetworkId: +network }}
                // filters={[
                //     { name: 'export', type: 'button', text: 'Export', onClick: () => InformationExport(network), icon: 'download', align: 'right' },
                //     { name: 'import', type: 'uploader', text: 'Import', customRequest: importData, icon: 'upload', align: 'right' }
                // ]}
                nameField='type'
                skipNewButton={count >= 5}
                onLoaded={(data) => { setCount(data ? data.length : 0); }}
                listName={'information_' + network}
            />

        </div>
    );
}

export default connect(state => ({ network: state.network }))(Information);
